<p-table [showGridlines]="true"
  [value]="searchResult?.Result"
  [paginator]="true"
  [rows]="searchParams ? searchParams.PageSize : 10"
  [totalRecords]="searchResult?.TotalCount"
  (onLazyLoad)="lazyLoad($event)"
  [lazy]="true"
  [loading]="loading"
>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="ProfileId">
        {{ 'contact-records.search.profile' | translate | ucfirst }}
        <p-sortIcon field="ProfileId"></p-sortIcon>
      </th>
      <th pSortableColumn="Subject">
        {{ 'contact-records.search.subject' | translate | ucfirst }}
        <p-sortIcon field="Subject"></p-sortIcon>
      </th>
      <th pSortableColumn="ContactDate">
        {{ 'contact-records.search.date' | translate | ucfirst }}
        <p-sortIcon field="ContactDate"></p-sortIcon>
      </th>
      <th pSortableColumn="Contactee">
        {{ 'contact-records.search.user' | translate | ucfirst }}
        <p-sortIcon field="Contactee"></p-sortIcon>
      </th>
      <th pSortableColumn="ContactType">
        {{ 'contact-records.search.contact-type' | translate | titlecase }}
        <p-sortIcon field="ContactType"></p-sortIcon>
      </th>
      <th class="action-column"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-contactRecord>
    <tr>
      <td>
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-5">
          <wl-profile-type-icon
            [profileId]="contactRecord.ProfileId"
            [isOrg]="contactRecord.ProfileIsOrg"
            [isMember]="contactRecord.ProfileIsMember"
          ></wl-profile-type-icon>
          <a [routerLink]="['/profile', contactRecord.ProfileId]">{{ contactRecord.ProfileReportName }}</a>
        </div>
      </td>
      <td>
        {{ contactRecord.Subject }}
      </td>
      <td>
        {{ contactRecord.ContactDate | date: 'M/d/yyyy' }}
      </td>
      <td>
        {{ contactRecord.Contactee }}
      </td>
      <td>
        {{ contactRecord.ContactType }}
      </td>
      <td class="action-column">
        <a [routerLink]="['/profile', contactRecord.ProfileId, 'contacts']">
          {{ 'contact-records.search.manage' | translate | ucfirst }}
        </a>
      </td>
    </tr>
  </ng-template>
</p-table>
